// extracted by mini-css-extract-plugin
export default {"button":"Button_button__A76z0","text":"Button_text__vK8pB","glowing":"Button_glowing__HuY86"};